import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* Auto-generated. Do not edit! */
/* eslint-disable */

const SvgCheckboxChecked = props => /*#__PURE__*/_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "rgb(0 0 0 / 60%)",
  ...props,
  children: [/*#__PURE__*/_jsx("mask", {
    id: "a",
    fill: "#fff",
    children: /*#__PURE__*/_jsx("rect", {
      width: 16,
      height: 16,
      x: 4,
      y: 4,
      rx: 4
    })
  }), /*#__PURE__*/_jsx("rect", {
    width: 16,
    height: 16,
    x: 4,
    y: 4,
    mask: "url(#a)",
    rx: 4
  }), /*#__PURE__*/_jsx("path", {
    fill: "#fff",
    d: "M10.382 15.808a.77.77 0 0 1-.564-.244L7 12.747a.75.75 0 0 1-.22-.572.8.8 0 0 1 .237-.572.77.77 0 0 1 .568-.228.77.77 0 0 1 .567.228l2.262 2.261L15.86 8.42a.76.76 0 0 1 .555-.23.76.76 0 0 1 .56.23.76.76 0 0 1 .228.558q0 .33-.228.557l-6.03 6.03a.772.772 0 0 1-.564.245"
  })]
});
export default SvgCheckboxChecked;